import { cn } from "@/utils/classnames"
import { MagnifyingGlassIcon } from "@heroicons/react/24/outline"
import { forwardRef, InputHTMLAttributes } from "react"

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string
  wrapperClassName?: string
  expanded?: boolean
}

/**
 * @deprecated This component is deprecated and will be removed in future versions.
 * Please use the TextInput component instead.
 */
const Input = forwardRef<HTMLInputElement, InputProps>(({ wrapperClassName, ...props }, ref) => {
  return (
    <div className={cn("relative", wrapperClassName)}>
      {props.type === "search" && (
        <div className={cn("pointer-events-none absolute inset-y-0 left-0 flex items-center pl-[11px]")}>
          <span className="sm:text-sm">
            <MagnifyingGlassIcon height={22} />
          </span>
        </div>
      )}
      <input
        ref={ref}
        {...props}
        style={{
          ...(props.type === "password" && {
            letterSpacing: "0.125em",
          }),
        }}
        className={cn(
          "h-10 rounded-full border border-bg-2 bg-bg-2 py-2 pl-4 outline-none transition-all text-h7-lg focus:outline-none focus:ring-0",
          { "pl-10": props.type === "search" },
          props.expanded ? "w-auto pr-4" : "w-[40px]",
          props.className
        )}
      />
    </div>
  )
})

Input.displayName = "Input"

export default Input
